module.exports = __webpack_public_path__ + "static/media/Bayleigh-Reedy.666e5f58.jpg";